import { Flex, Typography } from 'antd';
import { HEALTH_DATA_FIELDS } from 'constants/patients';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PatientFragmentFragment } from '__generated__/graphql';

import HealthDetailsItem from './HealthDetailsItem';
import { DetailsBody, StyledCard } from './styled';

const { Title } = Typography;

interface IProps {
  data: Omit<PatientFragmentFragment, '__typename' | 'id'> & {
    __typename?: 'Patient' | 'User';
    id: string | null;
  };
}

const PatientHealthDetails: FC<IProps> = ({ data }) => {
  const { t } = useTranslation();

  return (
    <StyledCard>
      <Flex vertical>
        <Title level={5} style={{ marginBottom: 16 }}>
          {t('appointments_details.health_details')}
        </Title>
        <DetailsBody>
          {HEALTH_DATA_FIELDS.map(item => (
            <HealthDetailsItem
              key={item.stepKey}
              title={item.title}
              stepKey={item.stepKey}
              optionsKey={item.optionsKey}
              otherKey={item.otherKey}
              unitKey={item.unitKey}
              gender={item.gender}
              patientData={data}
            />
          ))}
        </DetailsBody>
      </Flex>
    </StyledCard>
  );
};

export default PatientHealthDetails;
